<template>
    <el-select
        v-model="modelValue"
        :value-key="valueKey"
        :clearable="clearable"
        :value="value"
        :disabled="disabled"
        multiple
        @change="change"
        @remove-tag="removeTag"
        :popper-append-to-body="false"
    >
        <el-option
            v-for="item in options"
            :key="item[valueField]"
            :label="item[labelField]"
            :value="item[valueField]"
            :disabled=item[disabledField]
        >
        </el-option>
    </el-select> <!-- @change="test" -->
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String, Array, Object],
            default: "",
        },
        valueKey: {
            type: String,
            default: "value",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "value",
        },
        disabledField:{
            type: String,
            default: "disabled",
        },
        clearable:{
            type: Boolean,
            default: false,
        }
    },
    created(){
        console.log("options",this.options)
    },
    computed: {
        modelValue: {
            get({ value, $attrs }) {
               // if (!Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        test(event){
            console.log(event);
            console.log("value:"+this.value);
            console.log("valueKey:"+this.valueKey);
            console.log("disabled:"+this.disabled);
            console.log("options:"+this.options);
            console.log("labelField:"+this.labelField);
            console.log("valueField:"+this.valueField);
        },
        change(selectedvalue){
            this.$emit("confsitechange",selectedvalue)
        },
        removeTag(selectedvalue){
            this.$emit("removeTag",selectedvalue)
        }

    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner:focus {
    border-color: var(--main-color) !important;
}
.option-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.el-select .el-select-dropdown__item {
  max-width: 400px;
}
</style>